/**
 * All JavaScript required for mobile navigation
 *
 * @component mobileNav
 */

class mobileNav {
    constructor(){
        // animate mobile button
        $('.c-mobile-button__items').on('click',function(){
            $(this).toggleClass('is-open');
            $('.c-mobile-nav').toggleClass('is-open');

            $('html, body').animate({
                scrollTop: 0
            }, 400);
        });

    }
}

export default new mobileNav();
